module.exports = __webpack_public_path__ + "static/media/pic2.593e5328.png";